<template>
	<div class="card-panel-main">
		<div class="card-panel-main-header">{{title}}</div>
		<div class="card-panel-main-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import {defineComponent} from "vue"
	
	export default defineComponent({
		name: "cardPanel",
		props: {
			title: {
				type: String,
				default: ""
			}
		}
	})
</script>

<style lang="scss" scoped>
	@import "@/assets/styles/_handle.scss";
	
	.card-panel-main {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		@include background_color("panel-container-bg-color");
		border-radius: 6px;
		@include border_all("panel-container-border");
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		box-sizing: border-box;
		overflow: hidden;
		
		.card-panel-main-header{
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			align-content: center;
			box-sizing: border-box;
			padding-left: 20px;
			line-height: 18px;
			font-size: 18px;
			@include font_family("font_family");
			@include font_color("card-panel-font-color");
			@include border_bottom("card-panel-header-bottom-border");
		}
		
		.card-panel-main-body{
			width: 100%;
			flex: 1;
			box-sizing: border-box;
		}
	}
</style>
